var map = {
	"./1.jpg": "tGse",
	"./2.jpg": "2Bxi",
	"./3.jpg": "lQgp",
	"./4.jpg": "poA4",
	"./CommLabor.jpg": "4hPw",
	"./Pdf.jpg": "XdTb",
	"./PrincSecretaryLab.jpg": "sODT",
	"./asstCommLabor.jpg": "KJeY",
	"./boxed-pattern.png": "9wS/",
	"./cabinate.png": "bKie",
	"./cm-maha.jpg": "QtGz",
	"./css/Site.css": "D3/h",
	"./css/fontawesome-all.css": "9Ml/",
	"./css/style.css": "VaBq",
	"./images/0.png": "v7xU",
	"./images/CM.jpg": "hBR6",
	"./images/Sambhajirao.jpg": "GfeC",
	"./images/about_client.jpg": "lsLS",
	"./images/about_us.png": "1pqF",
	"./images/about_us_SB.png": "DmmL",
	"./images/achievments.jpg": "g9Ys",
	"./images/achievments_bg.jpg": "FQXs",
	"./images/achievments_bg1.jpg": "PCnd",
	"./images/banner-bg.jpg": "tTqm",
	"./images/blog/blog_hed-1.jpg": "+8aA",
	"./images/blog/lb-1.jpg": "AUv3",
	"./images/blog/lb-2.jpg": "VWPw",
	"./images/blog/lb-3.jpg": "dM+t",
	"./images/blog/renovation/r-1.jpg": "mFxO",
	"./images/blog/renovation/r-2.jpg": "X3mn",
	"./images/blog/renovation/r-3.jpg": "Ktbe",
	"./images/blog/renovation/r-4.jpg": "bYQC",
	"./images/blog/renovation/r-5.jpg": "4+c3",
	"./images/blog/renovation/r-6.jpg": "MEck",
	"./images/blog/renovation/r-7.jpg": "KTbw",
	"./images/blog/renovation/r-8.jpg": "08mI",
	"./images/blog/renovation/r-9.jpg": "xIje",
	"./images/blog/rs-1.jpg": "5gbC",
	"./images/blog/rs-2.jpg": "qHzm",
	"./images/blog/rs-3.jpg": "9pYp",
	"./images/cabinate.png": "34+R",
	"./images/client_logo/1.jpg": "Mcgf",
	"./images/client_logo/10.jpg": "mbcW",
	"./images/client_logo/11.jpg": "Jwbn",
	"./images/client_logo/12.jpg": "ksei",
	"./images/client_logo/13.jpg": "ZOc4",
	"./images/client_logo/14.jpg": "ZBn5",
	"./images/client_logo/15.jpg": "HSPk",
	"./images/client_logo/16.jpg": "9HBH",
	"./images/client_logo/2.jpg": "kbEm",
	"./images/client_logo/3.jpg": "VoXe",
	"./images/client_logo/4.jpg": "xH4C",
	"./images/client_logo/5.jpg": "8nWI",
	"./images/client_logo/6.jpg": "nqra",
	"./images/client_logo/7.jpg": "U2t3",
	"./images/client_logo/8.jpg": "fTSf",
	"./images/client_logo/9.jpg": "6q2C",
	"./images/client_logo/client_logo-1.png": "4fnR",
	"./images/client_logo/client_logo-2.png": "7/iI",
	"./images/client_logo/client_logo-3.png": "h1fJ",
	"./images/client_logo/client_logo-4.png": "SyPj",
	"./images/client_logo/client_logo-5.png": "SVHE",
	"./images/client_logo/gov1.png": "Fa/e",
	"./images/client_logo/gov2.jpg": "9CK8",
	"./images/client_logo/gov3.jpg": "bYmU",
	"./images/client_logo/swach-bharat.png": "yXzm",
	"./images/client_logo/vima.jpg": "UsCU",
	"./images/close.png": "/TeD",
	"./images/cns-1.jpg": "30fR",
	"./images/cns-2.jpg": "kTlw",
	"./images/cns-3.jpg": "459f",
	"./images/comm.png": "3CfJ",
	"./images/construction-2.jpg": "s3a8",
	"./images/construction.jpg": "jkOC",
	"./images/download.svg": "SZCR",
	"./images/favicon.png": "1H3f",
	"./images/feature-man-4.jpg": "M3nq",
	"./images/footer-logo.png": "DSQX",
	"./images/footer.jpg": "5iLX",
	"./images/gallery/gl-1.jpg": "HdSL",
	"./images/gallery/gl-2.jpg": "wxJm",
	"./images/gallery/gl-3.jpg": "mIIG",
	"./images/gallery/gl-4.jpg": "b6QW",
	"./images/gallery/gl-5.jpg": "W+aq",
	"./images/gallery/gl-6.jpg": "rtZ8",
	"./images/gallery/gl-7.jpg": "/nHj",
	"./images/gallery/gl-8.jpg": "tlXP",
	"./images/gallery/sv-1.jpg": "bAE3",
	"./images/gallery/sv-2.jpg": "wS0V",
	"./images/gallery/sv-3.jpg": "eMc+",
	"./images/gallery/sv-4.jpg": "jH/E",
	"./images/gallery/sv-5.jpg": "BEIC",
	"./images/gallery/sv-6.jpg": "ejJq",
	"./images/guards.jpg": "LVN1",
	"./images/guards3.jpg": "iUe8",
	"./images/guards4.jpg": "oThn",
	"./images/guardsold.jpg": "a5s5",
	"./images/ias.png": "7J0g",
	"./images/labour_dept_logo_new.png": "rN/V",
	"./images/loading.gif": "F7NO",
	"./images/logo.jpg": "4GjL",
	"./images/logo.png": "iQH9",
	"./images/logo_trans.png": "a+8q",
	"./images/newstatemin.jpeg": "wbis",
	"./images/next.png": "3aVt",
	"./images/preloader.gif": "5va1",
	"./images/prev.png": "xb5a",
	"./images/protfolio_bg.jpg": "qztS",
	"./images/sgb.jpg": "Xa8b",
	"./images/sgb_logo_new.png": "u7zL",
	"./images/slider-1.jpg": "ZZtB",
	"./images/slider-11.jpg": "ufSB",
	"./images/slider-2.jpg": "+W++",
	"./images/slider-22.jpg": "/TOy",
	"./images/slider-33.jpg": "2oZP",
	"./images/slider-44.jpg": "ZoDz",
	"./images/slider-55.jpg": "lx2Q",
	"./images/slider-66.jpg": "N0hh",
	"./images/slider-77.jpg": "M89j",
	"./images/stateminister.jpg": "MTjI",
	"./images/team/tm-1.jpg": "/0u9",
	"./images/team/tm-2.jpg": "v4z8",
	"./images/team/tm-3.jpg": "/9hw",
	"./images/team/tm-4.jpg": "tO21",
	"./images/team/tm-5.jpg": "PY2O",
	"./images/team/tm-6.jpg": "qMkK",
	"./images/team/tm-7.jpg": "bDKq",
	"./images/team/tm-8.jpg": "ayo/",
	"./images/test_top1.jpg": "5Bz3",
	"./images/top_image1.png": "4XYl",
	"./images/top_image2.png": "suWI",
	"./images/top_image3.png": "rWgP",
	"./laborMin.jpg": "Bwr1",
	"./laborOffcr.png": "pPBE",
	"./lion.jpg": "cOtp",
	"./logo.png": "7Otq",
	"./nilangekar.jpg": "PkKq",
	"./pdfIcon.png": "SW/l",
	"./stateLaborMin.jpg": "/do1",
	"./texture-bw.png": "2Pa5",
	"./texture-turquoise.png": "NqWt",
	"./texture-violet.png": "N9EL",
	"./ui-design_02.jpg": "iOjC",
	"./webfonts/fa-brands-400.eot": "TpI3",
	"./webfonts/fa-brands-400.svg": "jTDg",
	"./webfonts/fa-brands-400.ttf": "0sle",
	"./webfonts/fa-brands-400.woff": "NBd9",
	"./webfonts/fa-brands-400.woff2": "9iSo",
	"./webfonts/fa-regular-400.eot": "1uWz",
	"./webfonts/fa-regular-400.svg": "gNJU",
	"./webfonts/fa-regular-400.ttf": "hiYv",
	"./webfonts/fa-regular-400.woff": "sItb",
	"./webfonts/fa-regular-400.woff2": "QSS9",
	"./webfonts/fa-solid-900.eot": "3ZDI",
	"./webfonts/fa-solid-900.svg": "48Yc",
	"./webfonts/fa-solid-900.ttf": "tR0v",
	"./webfonts/fa-solid-900.woff": "oLdV",
	"./webfonts/fa-solid-900.woff2": "4dHM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0